import React from 'react'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { ITabData, TTabKey } from './types'
import { TabKeys } from './consts'
import VideosTab from './VideosTab'
import ImagesTab from './ImagesTab'

export const TABS: ITabData[] = [
  {
    key: TabKeys.VIDEOS,
    label: translate(T.VIDEOS_LABEL),
    content: <VideosTab />
  },
  {
    key: TabKeys.IMAGES,
    label: translate(T.IMAGES_LABEL),
    content: <ImagesTab />
  }
]

export const getTabsData = (): { name: TTabKey; text: string }[] =>
  TABS.map(tab => ({
    name: tab.key,
    text: tab.label
  }))

export const getTabContent = (key: string): React.ReactNode => {
  const tab = TABS.find(t => t.key === key)
  return tab?.content || null
}
